type Props = { goals?: string[]; activeGoal?: string };

export function BusinessGoalsGrid({ goals = [], activeGoal = 'Revenue Growth' }: Props) {
  return (
    <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {goals.map((g) => (
        <button
          key={g}
          type="button"
          className={`rounded-lg border px-3 py-2 text-left text-xs font-medium transition ${
            g === activeGoal
              ? 'border-brand-600 bg-brand-50 text-brand-700 dark:border-brand-500 dark:bg-brand-950 dark:text-brand-300'
              : 'border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400'
          }`}
        >
          {g}
        </button>
      ))}
    </div>
  );
}
